import {
  dimensions,
  flaggedItem,
  mountType,
  category,
  customProduct,
  specialtyShape,
} from './validators';

export default [
  dimensions,
  specialtyShape,
  flaggedItem,
  mountType,
  category,
  customProduct,
];
